@if (!resetCode) {
  <div class="form-area">
    <div>
      <img
        class="logo"
        src="../../../assets/img/motion-R.png"
      >
      <div>
        <h4>Password Reset</h4>
        @if (!submittedUsername) {
          <p>
            Enter your Motion username to reset your password
          </p>
        }
        @if (submittedUsername) {
          <p>
            If you provided a valid username with an email address on file, you should be receiving an email from us shortly.
          </p>
        }
      </div>
    </div>

    @if (!submittedUsername) {
      <div>
        <form>
          <div>
            <input
              type="text"
              name="username"
              spellcheck="false"
              autocomplete="off"
              placeholder="Motion Username"
              aria-label="Motion Username"
              [(ngModel)]="enteredUsername"
            >
          </div>

          <div class="bottom">
            <button
              type="button"
              [ngClass]="{'loading': submittingUsername}"
              (click)="createPasswordReset()"
            >
              <span>Reset Password</span>
              <motn-spinner></motn-spinner>
            </button>
          </div>
        </form>
      </div>
    }

    <motn-login-help-buttons
      [excludeButtons]="['forgot-password']"
    ></motn-login-help-buttons>
  </div>
}

@if (resetCode) {
  <div class="form-area">
    <div>
      <img
        class="logo"
        src="../../../assets/img/motion-R.png"
      >
      <div>
        <h4>Password Reset</h4>
        @if (!submittedPassword) {
          <p>
            Provide a new password for logging into your account.
          </p>
        }
        @if (submittedPassword) {
          <p>
            Success! Your password was changed. Please log in again.
          </p>
        }
      </div>
    </div>

    @if (!submittedPassword) {
      <div>
        <form>
          <div>
            <input
              type="password"
              name="password1"
              placeholder="Password"
              [(ngModel)]="enteredPassword1"
            >
          </div>
          <div>
            <input
              type="password"
              name="password2"
              placeholder="Confirm Password"
              [(ngModel)]="enteredPassword2"
            >
          </div>

          <div class="bottom">
            <button
              type="button"
              [ngClass]="{'loading': submittingPassword}"
              (click)="performPasswordReset()"
            >
              <span>Reset Password</span>
              <motn-spinner></motn-spinner>
            </button>
          </div>
        </form>
      </div>
    }

    <motn-login-help-buttons
      [excludeButtons]="['forgot-password']"
    ></motn-login-help-buttons>
  </div>
}
